<br>
  <br>
    <div class="main-container-pe-configuration">
      <div class="table-container">
        <form [formGroup]="configForm" autocomplete="off">
          <ng-container formArrayName="configRows">
            <table mat-table [dataSource]="dataSource" class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">
              <ng-container matColumnDef="headertitle">
                <th class="title-col" mat-header-cell *matHeaderCellDef colspan="4">
                  <div class="pull-left">
                    <h4>{{title}}</h4>
                  </div>
                  <div class="align-right">
                    <button mat-raised-button (click)="checkUserHistory($event)" class="btn button-fix button-color-fix-purple">
                      Check Configuration History
                      <mat-icon class=" icon-color-fix">history</mat-icon>
                    </button>
                  </div>
                </th>
              </ng-container>
              <ng-container matColumnDef="configField">
                <th mat-header-cell *matHeaderCellDef style="width:35%"> Configuration Field </th>
                <td mat-cell *matCellDef="let element; let i = index" class="fixed-row-height" style="width:35%">
                  <p>{{getFormValue(i).ConfigFieldPretty}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="configValue">
                <th mat-header-cell *matHeaderCellDef style="width:35%"> Configuration Value </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="fixed-row-height" style="width:35%">
                  <!-- TEXT -->
                  @if (getFormValue(i).Type === 'string' && !getFormValue(i).OnEdit) {
                    <p style="width:100%">
                      {{getFormValue(i).ConfigValue}}
                    </p>
                  }
                  @if (getFormValue(i).Type === 'string' && getFormValue(i).OnEdit) {
                    <mat-form-field floatLabel="auto" style="width:100%">
                      <input matInput
                        [value]="getFormValue(i).ConfigValue"
                        [maxlength]="getFormValue(i).MaxLength"
                        formControlName="ConfigValue">
                      </mat-form-field>
                    }
                    <!-- DATE -->
                    @if (getFormValue(i).Type === 'date' && !getFormValue(i).OnEdit) {
                      <p [innerHTML]="getFormValue(i).ConfigValue | date:'yyyy-MM-dd'"></p>
                    }
                    @if (getFormValue(i).Type === 'date' && getFormValue(i).OnEdit) {
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker"
                          formControlName="ConfigValue"
                          (dateChange)="getDateUTCChange($event, i)">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      }


                      <!-- ENUM -->
                      @if (getFormValue(i).Type === 'enum' && !getFormValue(i).OnEdit) {
                        <p>
                          {{getSelectorText(i)}}
                        </p>
                      }
                      @if (getFormValue(i).Type === 'enum' && getFormValue(i).OnEdit) {
                        <mat-form-field floatLabel="auto">
                          <mat-select style="min-width: 200px;" [(ngModel)]="getFormValue(i).ConfigValue" [ngModelOptions]="{standalone: true}" (selectionChange)="onEnumFieldChange($event, i)">
                            <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                            @for (eItem of getSelectorValues(i); track eItem) {
                              <mat-option [value]="eItem.id">
                                {{eItem.text}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }

                      <!-- ENUM MULTI (typeId, functionId) -->
                      @if ((getFormValue(i).Type === 'enum-multi') && !getFormValue(i).OnEdit) {
                        <p
                          [matTooltip]="getFormValue(i).ConfigField === 'functionIds' && getFormValue(i).ConfigValue.length > 1 ? getSelectorText(i, {forTooltip: true}) : ''"
                          matTooltipClass="my-tooltip-offset"
                          matTooltipPosition="right">
                          {{
                          getFormValue(i).ConfigField === 'functionIds' && getFormValue(i).ConfigValue.length > 1
                          ? getSelectorText(i)
                          : getSelectorText(i)
                          }}
                        </p>
                      }
                      @if ((getFormValue(i).Type === 'enum-multi') && getFormValue(i).OnEdit) {
                        <mat-form-field floatLabel="auto"
                          [style.display]="(getFormValue(i).Type === 'enum-multi' && getFormValue(i).OnEdit) ? '' : 'none'"
                          #tooltipRef="matTooltip"
                          [matTooltip]="getFormValue(i).ConfigField === 'functionIds' && getFormValue(i).ConfigValue.length > 1 ? getSelectorText(i, {forTooltip: true}) : ''"
                          [matTooltipShowDelay]="300"
                          matTooltipPosition="right">
                          <mat-select style="min-width: 200px;"
                            formControlName="ConfigValue"
                            multiple
                            (selectionChange)="onTypeIdSelectionChange($event, i)">
                            <mat-select-trigger>
                              @if (getFormValue(i).ConfigField === 'functionIds' && getFormValue(i).ConfigValue.length > 1) {
                                {{ getSelectorText(i) }}
                              } @else {
                                {{ getSelectorText(i) }}
                              }
                            </mat-select-trigger>
                            @for (eItem of getSelectorValues(i); track eItem) {
                              <mat-option [value]="eItem.id">
                                {{eItem.text}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="otherFunctionValue">
                    <th mat-header-cell *matHeaderCellDef style="width:20%"></th>
                    <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="fixed-row-height" style="width:20%">
                      @if (isFunctionIdOther(i)) {
                        <textareaoverlay
                                             [inputControls]="{
                                                     isOpenOverlay: otherFunctionControl.isOpenOverlay,
                                                     textAreaId: 'textAreaId',
                                                     isEditable: getFormValue(i).OnEdit,
                                                     maxCommentLength: otherFunctionControl.MaxLength,
                                                     comment: otherFunctionControl.ConfigValue,
                                                     placeholder: 'Please specify'
                                                 }"
                          [customSpanClass]="{'alternative2': getFormValue(i).OnEdit}"
                          (commentChange)="onOtherFunctionChange($event.comment)">
                        </textareaoverlay>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width:10%"> Actions </th>
                    <td mat-cell *matCellDef="let element; let i = index" class="fixed-row-height" style="width:10%">
                      @if (getFormValue(i).CanEdit && !getFormValue(i).OnEdit) {
                        <button mat-icon-button color="primary" matTooltip="Edit value" (click)="onRowEditInit(i)">
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                      @if (getFormValue(i).OnEdit) {
                        <button mat-icon-button color="warn" matTooltip="Discard changes" (click)="onRowEditCancel(i)">
                          <mat-icon>rotate_left</mat-icon>
                        </button>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="savefooter">
                    <th mat-footer-cell *matFooterCellDef colspan="4">
                      <div class="OrangeButton">
                        <button mat-raised-button type="submit" (click)="onSave()" [disabled]="!anyChange()" [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'" class="button-color-fix-orange button-fix pull-right">
                          Save
                          <mat-icon iconPositionEnd style="color:white !important" class="icon-color-fix">save</mat-icon>
                        </button>
                        <button mat-raised-button type="button" (click)="onCancel()" [disabled]="!anyChange()" [matTooltip]="anyChange()? 'Discard all unsaved changes' : 'No changes to cancel'" class="button-color-fix-grey button-fix pull-right">
                          Cancel
                          <mat-icon iconPositionEnd style="color:white !important" class="icon-color-fix">rotate_left</mat-icon>
                        </button>
                      </div>
                    </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['headertitle']; sticky: true" class="stickyTopz100"></tr>
                  <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay;" [class.alternative2]="getFormValue(i).OnEdit"></tr>
                  <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
                </table>
              </ng-container>
            </form>
          </div>
        </div>
